import { useEffect, useState } from "react";

export function useDelay(delay: number) {
  const [show, setShow] = useState(delay === 0);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return show;
}
